import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ManageUsersAccountService } from '../manage-users-account.service';
import { filter, map } from 'rxjs/operators';
import { UserTypes } from '../../config/user-types';

@Injectable({providedIn: 'root'})
export class ActivateGuard  {
  constructor(
    private _router: Router,
    private _authenticationService: ManageUsersAccountService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this._authenticationService.currentUserSubject.pipe(
      filter(e => !!e),
      map(user => {
        switch (user.activeusertype.usertypeid) {
          case UserTypes.Scheduler:
          case UserTypes.HubUser:
            return true;
        }
        return false;
      })
    );
  }
}
